export default __webpack_public_path__ + "static/media/vetrina_amazon.4d5ad6c0.png";